import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import KpiDashboard from '../kpi/KpiDashboard';//eslint-disable-line import/no-named-as-default
import * as appHelper from '../../../helpers/appHelper';
import * as kpiHelper from '../../../helpers/kpiHelper';
import * as dataHelper from '../../../helpers/dataHelper';
import * as objectConstants from '../../../constants/objectConstants';
import Resources from "../resourceLinks/ResourceLinks";
import _ from 'lodash';

class OptionFeedback extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            feedback_options: props.feedback_options,
            scoreKpi: kpiHelper.getScoreKpi(this.props.bite),
            kpiDashboardParams: {
                responseReview: true,
                showTitle: false,
                showImmediateImpact: true,
                allowUpdates: false,

            },
            hideScoreKpi: true,
            optionResourceLinks: props.optionResourceLinks,
            hasOptionsResources: props.hasOptionsResources,
            optionResourcesAreComplete: props.optionResourcesAreComplete,
            requiredResources: [],
            completedResources: [],
            checkResourcesComplete: false,
            resourcesAreComplete: true,
        };
        this.onOptionFeedbackRevealed = this.onOptionFeedbackRevealed.bind(this);
        this.setOptionClass = this.setOptionClass.bind(this);
        this.onResourceComplete = this.onResourceComplete.bind(this);
        this.getRequiredResources = this.getRequiredResources.bind(this);
        this.onCheckResourcesComplete = _.debounce(this.onCheckResourcesComplete.bind(this), 500);
    }

    componentDidMount() {
        //console.log(`feedback_options`, this.state.feedback_options);
        this.getRequiredResources();
    }

    componentWillReceiveProps(nextProps) {

        if (this.state.feedback_options !== nextProps.feedback_options) {
            this.setState({feedback_options: Object.assign([], nextProps.feedback_options)});
        }

    }

    componentDidUpdate(){
        if(this.state.checkResourcesComplete){
            this.onCheckResourcesComplete();
        }
    }

    onOptionFeedbackRevealed() {
        if (appHelper.isDefined(this.props.onComplete)) {
            this.props.onComplete();
        }
    }

    setOptionClass(option) {
        if (this.props.responseData.scoring_type === objectConstants.SCORING_TYPE_ASSESSED && appHelper.isDefined(this.state.scoreKpi.kpi_id)) {
            let scoreKpiResults = appHelper.getArrayObjectByKey(option.kpis, "kpi_id", this.state.scoreKpi.kpi_id);
            if (appHelper.isDefined(scoreKpiResults)) {
                return kpiHelper.getKpiPointsIndicatorClass(scoreKpiResults.value, scoreKpiResults.kpi_id).class;
            } else {
                return option.result;
            }
        } else {
            return option.result;
        }
    }

    onResourceComplete(resourceLinks) {
        //console.log(`onResourceComplete`,this.state.completedResources);
        let completedResources = Object.assign([],this.state.completedResources);
        let hasRequiredResources = false;
        _.forEach(resourceLinks, function (completeResourceLink) {

            //console.log(`completeResourceLink`,completeResourceLink);
            if (completeResourceLink.data.required){
                hasRequiredResources = true;
                //console.log(`onResourceComplete resource`);
                let completionIndex = appHelper.getArrayObjectIndexByKey(completedResources, "asset_id", completeResourceLink.data.asset_id);
                //console.log(`completionIndex`,completionIndex);
                if(completionIndex === -1) {
                    completedResources = dataHelper.immutablePush(completedResources, completeResourceLink.data);
                }
            }
        });

        //console.log(`completedResources`,completedResources);

        if(hasRequiredResources) {
            this.setState({
                completedResources: Object.assign([], completedResources), checkResourcesComplete: true,
            });
        }
    }

    getRequiredResources(){
        //console.log(`getRequiredResources`,this.state.optionResourceLinks);
        let requiredResources = [];
        _.forEach(this.state.optionResourceLinks, function (optionResourceLink) {
            if (optionResourceLink.required){
                requiredResources = dataHelper.immutablePush(requiredResources,optionResourceLink);
            }
        });

        this.setState({
            requiredResources: Object.assign([],requiredResources), checkResourcesComplete: true, resourcesAreComplete: requiredResources.length > 0
        });
    }

    onCheckResourcesComplete(){
         this.setState({
             checkResourcesComplete: false,
         });

        //console.log(this.state.completedResources, this.state.requiredResources);

         if(this.state.completedResources.length >= this.state.requiredResources.length){
             this.props.onOptionResourcesComplete();
         }
    }

    render() {
        return (
            <div className={`feedback-options-container`}>
                {this.state.feedback_options.map(feedback_option =>
                    feedback_option.options.length > 0 && feedback_option.feedback.length > 0
                        ?
                        <div className="feedback-options-panel" key={`${feedback_option.option_id}_panel`}>
                            <ul className="feedback-options">
                                {feedback_option.options.map(option =>
                                    <li className={`feedback-option ${option.className} ${this.setOptionClass(option)}`}
                                        key={option.option_id}>
                                        <div dangerouslySetInnerHTML={{__html: option.option_text}}/>
                                    </li>
                                )}
                            </ul>
                            {
                                feedback_option.feedback.length > 0 && feedback_option.feedback !== "<p><br></p>"
                                    ? <div className="feedback-option-feedback"
                                           dangerouslySetInnerHTML={{__html: feedback_option.feedback}}/>
                                    : null
                            }

                            {
                                feedback_option.resourceLinks.length > 0
                                    ?
                                    <Resources resources={feedback_option.resourceLinks}
                                               onResourcesComplete={this.onResourceComplete}/>
                                    :
                                    null
                            }
                        </div>
                        :
                        null
                )}
            </div>
        );
    }
}

OptionFeedback.propTypes = {
    feedback_options: PropTypes.array,
    asset_id: PropTypes.number.isRequired,
    bite: PropTypes.object,
    responseData: PropTypes.object,
    missedOptions: PropTypes.object,
    onComplete: PropTypes.func,
    optionResourceLinks: PropTypes.array,
    hasOptionsResources: PropTypes.bool,
    optionResourcesAreComplete: PropTypes.bool,
    onOptionResourcesComplete: PropTypes.func,
    actions: PropTypes.object
};

OptionFeedback.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    return {
        bite: appHelper.getBiteById(ownProps.responseData.bite_id)
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, {}), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(OptionFeedback);



/** WEBPACK FOOTER **
 ** ./src/components/objects/multipleChoice/OptionFeedback.js
 **/